import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { IoCopyOutline, IoCheckmarkOutline, IoWarningOutline } from 'react-icons/io5';
import './DepositCard.css';

const truncate = (addr) => (addr ? `${addr.slice(0, 10)}…${addr.slice(-8)}` : '');

const DepositCard = ({
  chain,
  address,
  networkName,
  usdtContractAddress,
  warningText,
  minPurchase,
  maxPurchase,
  calculator,
}) => {
  const [copied, setCopied] = useState(false);
  const [copiedContract, setCopiedContract] = useState(false);

  const copy = async (text, setter) => {
    try {
      await navigator.clipboard.writeText(text);
      setter(true);
      setTimeout(() => setter(false), 2000);
    } catch (_) { /* clipboard unavailable */ }
  };

  const standardLabel = {
    ethereum: 'Send USDT (ERC-20)',
    bsc: 'Send USDT (BEP-20)',
    tron: 'Send USDT (TRC-20)',
  }[chain] || 'Send USDT';

  if (!address) {
    return (
      <div className="deposit-card deposit-card-empty">
        <p>Deposit address not available yet. Please try again in a moment.</p>
      </div>
    );
  }

  return (
    <div className="deposit-card">
      <div className="deposit-card-header">
        <h3>{standardLabel}</h3>
        <div className="deposit-network">{networkName}</div>
      </div>

      {calculator}

      <div className="deposit-qr-wrap">
        <QRCodeCanvas
          value={address}
          size={220}
          level="M"
          includeMargin
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>

      <div className="deposit-address-row">
        <div className="deposit-address-label">Your unique deposit address</div>
        <div className="deposit-address-value">
          <code>{address}</code>
          <button
            type="button"
            className="deposit-copy-btn"
            onClick={() => copy(address, setCopied)}
            aria-label="Copy address"
          >
            {copied ? <IoCheckmarkOutline /> : <IoCopyOutline />}
            <span>{copied ? 'Copied!' : 'Copy'}</span>
          </button>
        </div>
      </div>

      <div className="deposit-warning">
        <IoWarningOutline />
        <span>
          {warningText ||
            `Only send USDT on the ${networkName} network to this address. Sending other tokens or using the wrong network will result in permanent loss of funds.`}
        </span>
      </div>

      {(minPurchase || maxPurchase) && (
        <div className="deposit-limits">
          {minPurchase ? <span>Min: {minPurchase} USDT</span> : null}
          {maxPurchase ? <span>Max: {maxPurchase} USDT</span> : null}
        </div>
      )}

      {usdtContractAddress && (
        <div className="deposit-contract">
          <div className="deposit-contract-label">USDT contract on {networkName}</div>
          <div className="deposit-contract-value">
            <code title={usdtContractAddress}>{truncate(usdtContractAddress)}</code>
            <button
              type="button"
              className="deposit-copy-btn small"
              onClick={() => copy(usdtContractAddress, setCopiedContract)}
            >
              {copiedContract ? <IoCheckmarkOutline /> : <IoCopyOutline />}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DepositCard;
